import { LoadingPopup } from 'components/pop-up';
import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParamService } from 'services';
import { authentication } from 'utils';

type Props = {

}

export const LoginCallback: FC<Props> = ({}) => {

    const params = useParamService
    const navigate = useNavigate()

    const error = params.getStringValue('error'),
          errorDescription = params.getStringValue('error_description'),
          code = params.getStringValue('code')

    useEffect(() => {
        const getToken = async () => {
            if(code) {
                await authentication.updateTokenFromCode(code)
                await navigate('/load-assignments')
            }
        }

        if(code) {
            getToken()
        }
    }, [])
    
    return (
        <>
            {error ? 
                <div>
                    <div>Something went wrong.</div>
                    <div>Error: {error}</div>
                    <div>Description: {errorDescription}</div>
                </div>
            :
                <LoadingPopup />
            }
        </>
    )
}